import { SaveButton } from "components/Buttons"
import React, { useState } from "react"
import { connect } from "react-redux"
import { Col, FormFeedback, Input, Label, Row } from "reactstrap"
import { generateDeepLinkCodes } from "store/actions"

const GenerateDeeplinkModal = ({
  menu_feature,
  vendorId,
  generateDeepLinkCodes,
  callback,
  loading,
  event_id,
  onClose,
}) => {
  const [numOfDeeplinks, setNumOfDeeplinks] = useState(1)

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Label for="numOfDeeplinks">How many deeplinks</Label>
          <Input
            id="numOfDeeplinks"
            value={numOfDeeplinks}
            onChange={event => {
              setNumOfDeeplinks(event.target.value)
            }}
            placeholder="How many deeplinks"
            invalid={numOfDeeplinks < 1}
            type="number"
            min={1}
          />
          <FormFeedback tooltip style={{ top: "-10%" }}>
            {!!numOfDeeplinks && numOfDeeplinks < 1 && "The min value is 1"}
            {!numOfDeeplinks && "This is required"}
          </FormFeedback>
        </Col>
      </Row>
      <Row className="my-3">
        <Col>
          <SaveButton
            type="button"
            content="Cancel"
            color="danger"
            onClick={onClose}
            fullWidth={true}
          />
        </Col>
        <Col>
          <SaveButton
            fullWidth={true}
            type="button"
            content="Generate"
            disabled={!numOfDeeplinks || numOfDeeplinks < 1}
            loading={loading}
            onClick={() => {
              generateDeepLinkCodes({
                type: 3,
                event_id: event_id,
                menu_item_id: menu_feature?.id,
                vendor_id: vendorId,
                count: numOfDeeplinks,
                callback: callback,
              })
            }}
          />
        </Col>
      </Row>
    </React.Fragment>
  )
}

export const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  loading: state.experiences.loading,
})

export const mapDispatchToProps = dispatch => ({
  generateDeepLinkCodes: values => dispatch(generateDeepLinkCodes(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GenerateDeeplinkModal)
